import {Button} from '@chekinapp/ui';
import {useTranslation} from 'react-i18next';
import incompleteIcon from 'assets/icons/incomplete.svg?no-inline';
import ModalSheet from 'components/common/ModalSheet';
import {ModalContent} from 'components/Modal/Modal';

type Props = {
  open: boolean;
  onClose: () => void;
};

export function IncompleteDataModal({open, onClose}: Props) {
  const {t} = useTranslation('identity-verification');

  return (
    <ModalSheet
      isOpenModalSheet={open}
      withCloseButton
      maxWidth={375}
      modalMobileHeight={'360px'}
      className="incomplete-data-modal"
      onClose={onClose}
      withModalMobileCloseButton
    >
      <div className="space-y-8 flex flex-col items-center w-full">
        <ModalContent
          title={t('incomplete_data_modal.title')}
          iconSrc={incompleteIcon}
          iconProps={{width: 67, height: 67}}
          text={t('incomplete_data_modal.description')}
        />
        <Button onClick={onClose} className="w-full">
          {t('ok')}
        </Button>
      </div>
    </ModalSheet>
  );
}
